module.exports = __webpack_public_path__ + "static/media/29.af00089.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/29.wav
// module id = oPnG
// module chunks = 0